module.exports = __webpack_public_path__ + "img/camera.61961299.svg";